import { Building2Icon } from 'assets/icons';

// A company in a list: the building in its square, its trade name over its
// company name (lighter and smaller, 13 px), cut short past 230 px so the
// other columns keep their room.
const CompanyIdentity = ({ name, legalName }) => (
  <span className="flex min-w-0 max-w-[230px] items-center gap-3">
    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-700">
      <Building2Icon wh={20} color="currentColor" />
    </span>
    <span className="min-w-0">
      <span className="block truncate font-medium uppercase text-gray-900">{name}</span>
      <span className="block truncate text-[13px] font-light uppercase leading-[18px] text-gray-400">{legalName || '-'}</span>
    </span>
  </span>
);

export default CompanyIdentity;
